import '../styles/ui.css'

export default function AiQueryPage() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            gap: 'var(--space-4)',
            textAlign: 'center',
            padding: 'var(--space-8)'
        }}>
            <div style={{ fontSize: '3rem' }}>✦</div>
            <h1 style={{ margin: 0, fontSize: '1.75rem' }}>AI Query</h1>
            <p style={{
                color: 'var(--color-text-secondary)',
                maxWidth: '420px',
                lineHeight: 1.6
            }}>
                Ask natural-language questions about your sales data and get
                instant answers powered by AI.
            </p>
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 16px',
                borderRadius: '999px',
                fontSize: '0.8rem',
                fontWeight: 600,
                background: 'var(--color-surface-elevated, rgba(255,255,255,0.06))',
                color: 'var(--color-text-secondary)',
                border: '1px solid var(--color-border, rgba(255,255,255,0.1))'
            }}>
                Coming Soon
                <span style={{
                    padding: '2px 8px',
                    borderRadius: '999px',
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    background: 'var(--color-accent, #7c3aed)',
                    color: '#fff'
                }}>Beta</span>
            </span>
        </div>
    )
}
